import { render, staticRenderFns } from "./UploadArtworkDialog.vue?vue&type=template&id=7b8da795&scoped=true"
import script from "./UploadArtworkDialog.vue?vue&type=script&lang=ts"
export * from "./UploadArtworkDialog.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./UploadArtworkDialog.vue?vue&type=style&index=0&id=7b8da795&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7b8da795",
  null
  ,true
)

export default component.exports